<!--<template>
        <svg width="2em" height="1.5em" viewBox="0 0 16 16" class="bi bi-check2" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
        </svg>
</template> -->

<script>

export default{
    data(){
        return {
            path:`<path fill-rule="evenodd" d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>`,
            svg:`<svg width="2em" height="1.5em" viewBox="0 0 16 16" class="bi bi-check2" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                   <path fill-rule="evenodd" d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                </svg>`
        }
    },
   props:['wrapcontentwithbutton'],
    render(h) {
        if(!this.wrapcontentwithbutton || this.wrapcontentwithbutton == false)
            return h('svg',{
                 class: 'bi bi-check2',
                 domProps:{innerHTML:this.path},
                 attrs:{
                    width:'2em',
                    height:'1.5em',
                    viewBox:'0 0 16 16',
                    fill:'currentColor',
                    xmlns:'http://www.w3.org/2000/svg',
                 },
                 on: this.$listeners,
          });
        return h('button', {domProps:{innerHTML:this.svg}})
    }
}

</script>


<style lang="scss" scoped>
svg{ 
    color: #939393;
}

svg:hover{
    color: #eee;
}

button{
    width:auto;
    height: auto;
    display: inherit;
}
</style>